import "can/model/";

export default can.Model.extend(
    {
        findAll: function (params, headers) {
            const requestHeaders = headers ? headers : {};
            const queryParams = params ? `?${can.param(params)}` : '';

            return can.ajax({
                url: `/api/v2/accountProperties${queryParams}`,
                type: "GET",
                dataType: "json",
                headers: requestHeaders,
            });
        },

        findOne: "GET /api/v2/accountProperties/{id}",

        parseModels: function (data) {
            const results = [];

            data.forEach(function (prop) {
                if (prop.name == "hos.driverhistory.editreasons") {
                    var propValue = prop.value.replace(/\"/g, "").split(",");

                    if (propValue[0]) {
                        _(propValue).forEach((item) => {
                            let code = item.split("|");
                            results.push({
                                default: code[0] === "Default" ? true : false,
                                reason:
                                    code[0] === "Default" ? code[1] : code[0],
                            });
                        });

                        prop.value = _.orderBy(results, ["reason"]);
                    }
                }
            });

            return data;
        },

        create: function (params) {
            const headers = params.headers ? params.headers : {};

            return can.ajax({
                url: "/api/v2/accountProperties",
                type: "POST",
                data: JSON.stringify(params.accountProperty),
                contentType: "application/json",
                headers: headers,
            });
        },

        update: function (id, params) {
            const headers = params.headers ? params.headers : {};

            return can.ajax({
                url: "/api/v2/accountProperties",
                type: "PUT",
                data: JSON.stringify(params.accountProperty),
                contentType: "application/json",
                headers: headers,
            });
        },

        destroy: "DELETE /api/v2/accountProperties/{id}",

        /**
         * Retrieves some particular account property based on the collection of property names
         * provided.
         * @param {array} accountPropertyNames Collection of account property name.
         * @returns {array} Collection of account properties.
         */
        findSomeAccountPropertyNamesOf: function (accountPropertyNames = []) {
            const deferred = can.Deferred();
            const deferredQuery = [];

            accountPropertyNames.forEach((accountPropsName) => {
                deferredQuery.push(
                    this.findAll({
                        name: accountPropsName,
                    })
                );
            });

            Promise.all(deferredQuery).then((res) => {
                Promise.all(
                    res.map((item) =>
                        item[0] && !!item[0].serialize ? item[0].serialize() : ""
                    ).filter(item => item)
                ).then((data) => {
                    deferred.resolve(data);
                });
            });

            return deferred.promise();
        },
    },
    {}
);
